import { Box  } from '@mui/material';
import React from 'react';
import SalesAnalyticsPage from 'containers/pages/salesAnalytics/salesAnalyticsPage';

const SalesAnalytics = () => {
	return (
		<Box display={'flex'} flexDirection={'column'} flexGrow={1}>
			<SalesAnalyticsPage />
		</Box>
	);
};

export default SalesAnalytics;
  